import { cva } from '@/styled-system/css';

export const inlineFeedbackLabelRecipe = cva({
  base: {
    textStyle: 'body',
  },
  variants: {
    tone: {
      critical: {
        color: 'InlineFeedback.critical.text',
      },
      info: {
        color: 'text.neutral',
      },
      success: {
        color: 'text.neutral',
      },
      transient: {
        color: 'text.neutral',
        fontStyle: 'italic',
      },
      warning: {
        color: 'text.neutral',
      },
    },
  },
});
